import { render } from "./RuiBellAdd.vue?vue&type=template&id=a49b62c0"
const script = {}
script.render = render

export default script